<template>
  <!--
    (2-col) 544
    sm:max-w-136
    (3-col) 816
    lg:max-w-204
    (4-col) 1088
    xl:max-w-272
  -->
  <ol
    v-if="usedArr(list)"
    :class="olClasses"
  >
    <li
      v-for="item in list"
      :key="item.slug"
      :class="liClasses"
    >
      <Card :post-obj="item" />
    </li>
  </ol>
</template>

<script>
import Card from '@/components/buttons/Card.vue'

export default {
  name: 'CardList',

  components: {
    Card
  },

  props: {
    list: {
      type: Array,
      default: () => []
    },
    leftAlign: {
      type: Boolean,
      default: false
    },
  },

  computed: {
    olClasses() {
      return [
        'max-w-68 sm:max-w-136 lg:max-w-204 xl:max-w-272',
        'mx-auto mb-7 last:mb-0',
        `sm:flex justify-${this.leftAlign ? 'start' : 'center'} items-center flex-wrap`,
      ]
    },
    liClasses() {
      return [
        'my-2',
        'px-2',
      ]
    },
  },
}
</script>

